var link_viewer_default = {
  "fontElementMap": "_0Bj-r",
  "link": "Be0di",
  "linkInEditor": "WcYwj",
  "linkInViewer": "_89jR0",
  "toolbarUrlContainer": "gy5da",
  "toolbarUrl": "pXIbj",
  "toolbarUrlAnchor": "a4-pA"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
